import { startCase, toLower } from 'lodash/fp';

function capitalizeWords(str: string | undefined = ''): string {
  return startCase(toLower(str)).replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
}

export default capitalizeWords;
